class Query
	constructor: ->
		@criterias = []
		@sortByValues = []
		@withValues = []
		@withoutRelations = false
		@intervalGroupingData = {}
		@parameters = {}

	setPagination: (offset, limit) ->
		@pagination = {
			'offset': offset
			'limit': limit
		}

		return @

	addParameter: (name, value) ->
		if angular.isObject value
			value = JSON.stringify value
		@parameters[name] = value

		return @

	sortBy: (property, direction = 'ASC') ->
		@sortByValues.push {
			'property': property
			'direction': direction
		}

		return @

	intervalGrouping: (startTime, endTime, interval) ->
		@intervalGroupingData.startTime = startTime
		@intervalGroupingData.endTime = endTime
		@intervalGroupingData.interval = interval

	isSorted: ->
		return @sortByValues.length > 0

	clearSortBy: ->
		@sortByValues = []

	criteria: (property, comparator, value, setLogical) ->
		criteria = new Criteria property, comparator, value, setLogical

		@criterias.push criteria

		return criteria

	criteriaToJSON: ->
		list = []

		for criteria in @criterias
			for item in criteria.criterias
				list.push item

		return JSON.stringify list

	withoutAnyRelations: (value = true) ->
		@withoutRelations = value

		return @

	withIds: (entities...) ->
		for entity in entities
			if typeof entity == 'string'
				entity = {property: entity, type: 'id'}

			@with entity

		return @

	with: (entities...) ->
		@withoutAnyRelations false

		for entity in entities
			entityProperty = null
			entityType = 'simple'
			entityExcluded = false

			if typeof entity == 'string'
				entityProperty = entity
			else if angular.isObject(entity)
				entityProperty = entity.property

				if entity.type?
					entityType = entity.type

				if entity.exclude?
					entityExcluded = entity.exclude

			if entityProperty && !@withValues.includes(entityProperty)
				entity = new Entity entityProperty, entityType, entityExcluded

				@withValues.push entity

		return @

	without: (entities...) ->
		@with(entities[0])

		for entity in @withValues
			entity.exclude = true

		return @
